"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseUserFromEvent = exports.sendEvent = void 0;
function createEvent(name, detail) {
    var event;
    try {
        event = new CustomEvent(name, {
            detail: detail,
        });
    }
    catch (error) {
        event = document.createEvent('CustomEvent');
        if (detail) {
            event.initCustomEvent(name, true, true, detail);
        }
        else {
            event.initEvent(name, true, true);
        }
    }
    return event;
}
function sendEvent(type, data) {
    var event = createEvent(type, data);
    document.dispatchEvent(event);
}
exports.sendEvent = sendEvent;
function parseUserFromEvent(event) {
    var customEvent = event;
    if (!customEvent.detail
        || !Object.prototype.hasOwnProperty.call(customEvent.detail, 'user')) {
        return null;
    }
    return customEvent.detail.user;
}
exports.parseUserFromEvent = parseUserFromEvent;
//# sourceMappingURL=events.js.map